module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":{"feed_articles":"特別授業一覧","activity_list":"活躍一覧"},"data":{"entering_year":"%{year}年入社","school_name":"%{school}出身"}}}')
  delete Component.options._Ctor
}
